import { BrowserRouter, Routes as AppRoutes, Route, Navigate } from "react-router-dom";
import ResetPassword from "@/features/admin/reset-password/ResetPassword";
import SignInPage from "@/features/sign-in/SignInPage";
import CreatedAccount from "@/features/admin/sign-up/CreatedAccount";
import SignUpPage from "@/features/admin/sign-up/SignUpPage";
import PrivateRoutes from "@/routes/PrivateRoutes";
import AdminLayout from "@/features/admin-layout/AdminLayout";
import Profile from "@/features/admin/profile/Profile";
import ChangePassword from "@/features/admin/change-password/ChangePassword";
import Organizations from "@/features/organizations/Organizations";
import NewOrganization from "@/features/organizations/new-organization/NewOrganization";
import MenuEditor from "@/features/menu/MenuEditor";
import Settings from "@/features/admin/menus/settings/Settings";
import Templates from "@/features/templates/Templates";
import NewTemplate from "@/features/newTemplate/NewTemplate";
import TemplateEditor from "@/features/templates/TemplateEditor";
import TemplateSettings from "@/features/newTemplate/components/Settings";
import { OrganizationLayout, OrganizationTables, OrganizationAvatars } from "@/features/organizations/components";
import OrganizationContent from "@/pages/organization-content/OrganizationContent";
import OrganizationMenus from "@/pages/organization-menus/OrganizationMenus";
import OrganizationSettings from "@/pages/organization-settings/OrganizationSettings";
import OrganizationPage from "@/features/organizations/components/OrganizationPage";
import Faqs from "@/features/organizations/components/faqs/Faqs";
import UserOrganizationProvider from "@/features/users/UserOrganizationProvider";
import NewMenuWizard from "@/features/new-menu-wizard/NewMenuWizard";
import WebCanvas from "@/features/websites/WebCanvas";
import OrganizationDetails from "@/pages/organization-details/OrganizationDetails";
import OrganizationProvider from "@/features/websites/components/OrganizationProvider";
import OrganizationWebsites from "@/features/organizations/components/websites/Websites";
import NewWebsiteWizard from "@/features/organizations/components/websites/newWebsite/NewWebsitesWizard";
import WebsiteEditor from "@/features/website-editor/WebsiteEditor";
import SurveysPage from "@/features/surveys/SurveysPage";
import SurveyDetailsPage from "@/features/surveys/SurveyDetailsPage";
import SurveyEditPage from "@/features/surveys/SurveyEditPage";
import NotFoundPage from "@/features/not-found/NotFoundPage";
import SurveyAnswerPage from "@/features/surveys/SurveyAnswerPage";
import GlobalRoute from "./GlobalRoute";
import Quote from "@/features/quote/Quote";
import ThanksQuote from "@/features/quote/Thanks";
import QuoteDetails from "@/features/quote/QuoteDetails";
import WebsiteProvider from "@/features/websites/components/WebsiteProvider";
import Catalog from "@/features/catalog/Catalog";
import Checkout from "@/features/catalog/Checkout";
import Contact from "@/features/catalog/Contact";
import CatalogLayout from "@/features/catalog/components/CatalogLayout";
import routes from "@/constants/routes";
import NewWebsiteProvider from "@/pages/website/WebsiteProvider";
import Website from "@/pages/website/Website";
import MenuList from "@/pages/menu/components/MenuList";
import Menu from "@/pages/menu/Menu";
import Orders from "@/pages/organization-orders/Orders";

import IMenuProvider from "@/pages/menu/components/MenuProvider";
// checkout
import CheckoutPage from "@/pages/checkout/CheckoutPage";
import ContactForm from "@/pages/checkout/components/ContactForm";
import LocationForm from "@/pages/checkout/components/LocationForm";
import PaymentForm from "@/pages/checkout/components/PaymentForm";
import ConfirmationView from "@/pages/checkout/components/ConfirmationView/ConfirmationView";
import OrderStatusPage from "@/pages/order-status/OrderStatusPage";

const Routes = () => {
  return (
    <BrowserRouter>
      <AppRoutes>
        <Route element={<GlobalRoute />}>
          {/* DINE IN FLOW - DEPRECATED - TODO: Delete this in April 2025 */}
          <Route path="/comercios/:organizationId" element={<Navigate to="/familia-chang" replace />} />
          <Route path="/comercios/:organizationId/menu" element={<Navigate to="/familia-chang" replace />} />
          <Route path="/comercios/:organizationId/menu/:menuId" element={<Navigate to="/familia-chang" replace />} />
          <Route path="/comercios/:organizationId/contacto" element={<Navigate to="/familia-chang" replace />} />
          <Route path="/comercios/:organizationId/direccion" element={<Navigate to="/familia-chang" replace />} />
          <Route path="/comercios/:organizationId/pago" element={<Navigate to="/familia-chang" replace />} />
          <Route path="/comercios/:organizationId/checkout" element={<Navigate to="/familia-chang" replace />} />
          <Route path="/comercios/:organizationId/status" element={<Navigate to="/familia-chang" replace />} />
          <Route path="/comercios/:organizationId/gracias" element={<Navigate to="/familia-chang" replace />} />

          {/* SURVEY */}
          <Route path="/comercios/:organizationId/surveys/:surveyId/submit" element={<OrganizationProvider />}>
            <Route index element={<SurveyAnswerPage />} />
          </Route>

          {/* AUTHENTICATION */}
          <Route path={routes.login} element={<SignInPage />} />
          <Route path="sign-up" element={<SignUpPage />} />
          <Route path="sign-up/verify-email" element={<CreatedAccount />} />
          <Route path="reset-password" element={<ResetPassword />} />

          {/* Private */}
          <Route element={<PrivateRoutes />}>
            <Route path="/" element={<AdminLayout />}>
              <Route path="home" index element={<h2>Home</h2>} />
              <Route path="perfil" element={<Profile />} />
              <Route path="password" element={<ChangePassword />} />

              {/* Organization */}
              <Route
                path="/comercios"
                element={
                  <UserOrganizationProvider
                    websites // TODO: move this to websites page
                    content
                    tables
                    orders
                    categories
                  />
                }
              >
                <Route element={<OrganizationLayout />}>
                  <Route index element={<Organizations />} />
                  <Route path=":organizationId/contenido/:contentStatus/:contentId?" element={<OrganizationContent />} />
                  <Route path=":organizationId/mesas" element={<OrganizationTables />} />
                  <Route path=":organizationId/accesos" element={<OrganizationPage />} />
                  <Route path=":organizationId/avatars" element={<OrganizationAvatars />} />
                  <Route path=":organizationId/menus" element={<OrganizationMenus />} />
                  <Route path=":organizationId/detalles" element={<OrganizationDetails />} />
                  <Route path=":organizationId/websites" element={<OrganizationWebsites />} />
                  <Route path=":organizationId/configuraciones" element={<OrganizationSettings />} />
                  <Route path=":organizationId/faqs" element={<Faqs />} />
                  {/* Surveys */}
                  <Route path=":organizationId/surveys" element={<SurveysPage />} />
                  <Route path=":organizationId/surveys/:surveyId" element={<SurveyDetailsPage />} />
                  <Route path=":organizationId/surveys/:surveyId/edit" element={<SurveyEditPage />} />
                  <Route path=":organizationId/pedidos/:orderId?" element={<Orders />} />
                </Route>

                <Route path="crear" element={<NewOrganization />} />
              </Route>
            </Route>

            {/* ADMIN - MENU TOOLS */}
            <Route path="/comercios" element={<UserOrganizationProvider showOrderDetails={false} content />}>
              <Route path=":organizationId/menus/crear" element={<NewMenuWizard />} />
              <Route path=":organizationId/menus/:menuId">
                <Route path="editor" element={<MenuEditor />} />
                <Route path="configuracion" element={<Settings />} />
              </Route>
            </Route>

            {/* ADMIN - WEBSITE TOOLS */}
            <Route path="/comercios/:organizationId/websites/:websiteId" element={<NewWebsiteProvider />}>
              <Route index element={<Website />} />
              <Route path="editor" element={<WebsiteEditor />} />
            </Route>

            <Route path="/comercios:organizationId/websites/crear" element={<NewWebsiteWizard />} />

            {/* Templates */}
            <Route path="/plantillas" element={<UserOrganizationProvider showOrderDetails={false} content />}>
              <Route element={<OrganizationProvider />}>
                <Route index element={<Templates />} />
                <Route path="crear" element={<NewTemplate />} />
                <Route path=":templateId/:organizationId">
                  <Route path="editor" element={<TemplateEditor />} />
                  <Route path="configuracion" element={<TemplateSettings />} />
                </Route>
              </Route>
            </Route>
          </Route>

          {/* DOMAIN - WEBSITES */}
          <Route path="/" element={<OrganizationProvider websites content faqs />}>
            <Route element={<WebsiteProvider />}>
              <Route index element={<WebCanvas />} />
              <Route path="/cotizacion" element={<Quote />} />

              <Route element={<CatalogLayout />}>
                <Route path="/catalogo" element={<Catalog />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/contacto" element={<Contact />} />
                <Route path="/cotizacion/gracias" element={<ThanksQuote />} />
                <Route path="/cotizacion/:quoteId" element={<QuoteDetails />} />
              </Route>
            </Route>
          </Route>

          {/* HOSTED - WEBSITE */}
          <Route path=":organizationAlias" element={<NewWebsiteProvider />}>
            <Route index element={<Website />} />
            <Route element={<IMenuProvider />}>
              {/* MENUS */}
              <Route path="menus" element={<MenuList />} />
              <Route path="menus/:menuId?" element={<Menu />} />
              {/* ORDER CHECKOUT */}
              <Route path="orders/:orderId/checkout" element={<CheckoutPage />}>
                <Route path="contact" element={<ContactForm />} />
                <Route path="location" element={<LocationForm />} />
                <Route path="payment" element={<PaymentForm />} />
                <Route path="confirmation" element={<ConfirmationView />} />
              </Route>
              <Route path="orders/:orderId/status" element={<OrderStatusPage />} />
            </Route>
          </Route>

          <Route path="/*" element={<NotFoundPage />} />
        </Route>
      </AppRoutes>
    </BrowserRouter>
  );
};

export default Routes;
